/**
 * ResponsavelUsuarioCollection
 *
 * @author Simpli CLI generator
 */
import {PageCollection, HttpExclude, Request} from 'simpli-web-sdk'
import {ResponsavelUsuario} from '@/model/resource/ResponsavelUsuario'

@HttpExclude()
export class ResponsavelUsuarioCollection extends PageCollection<
  ResponsavelUsuario
> {
  constructor() {
    super(ResponsavelUsuario)
  }

  idResp: number | null = null

  queryAsPage() {
    return this.listResponsavelUsuario(this.idResp ?? 0)
  }

  async listAllUsuario() {
    return await Request.get(`/admin/responsavel-usuario`, {
      params: this.params,
    })
      .name('listResponsavelUsuario')
      .as(this)
      .getResponse()
  }

  async listResponsavelUsuario(id: number) {
    return await Request.get(`/admin/responsavel-usuario`, {
      params: {idResp: id, ...this.params},
    })
      .name('listResponsavelUsuario')
      .as(this)
      .getResponse()
  }

  async listCsvResponsavelUsuario(id: number) {
    return await Request.get(`/admin/responsavel-usuario/csv`, {
      params: {idResp: id, ...this.params},
    })
      .name('listCsvResponsavelUsuario')
      .as(this)
      .getResponse()
  }
}
